module.exports = __webpack_public_path__ + "assets/1ccb3431d4e7e0f40ecd1e64dea5b044.mp3";